export default "/images/vendor/@material-design-icons/svg/outlined/fast_rewind.svg?6580c3a6d072624a71787a8982f75c27";